<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    title="行车路线"
    width="70%"
  >
    <div
      id="container"
      style="width:100%;height:500px;"
    />
    <div
      slot="footer"
      class="dialog-footer"
      style="text-align:center;height:30px;line-height: 30px;"
    >
      <div style="float:left;display:flex;align-items:center;">
        <img src="@/assets/img/emp_makers.png" style="width:25px;height:25px;"/> 员工签到
        <img src="@/assets/img/driver_makers.png" style="width:25px;height:25px;margin-left:20px;"/> 司机签到
      </div>
      <el-button
        size="mini"
        @click="closeForm" style="float:right"
      >取消</el-button>
    </div>
    <div>
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="srcList" />
    </div>
  </el-dialog>
</template>
<script>
// 导入组件
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import startImg from '@/assets/img/start_makers.png'
import endImg from '@/assets/img/end_makers.png'
import tujingImg from '@/assets/img/tujing_makers.png'
import empImg from '@/assets/img/emp_makers.png'
import driverImg from '@/assets/img/driver_makers.png'
import { getClockList } from  "@/api/order/orderinfo"
import {directionTdMap} from "@/api/wayz";
import {wgs84_to_gcj02} from "@/util/converMapCoord";
export default {
  components: {
      ElImageViewer
  },
  computed: {
  },
  data() {
    return {
      visible: false,
      formName: '驳回',
      loading: false,
      rowInfo: {
      },
      clockInfos:[],//打卡信息
      map:null,
      waypoints:'', //途经坐标
      showViewer: false, // 显示查看器
      srcList:[],
    }
  },
  mounted() {
    //将callback方法绑定到window对象
    // window['callback'] = (data) => {
    //   this.callback(data)
    // };
    window['onPreview'] = (clockIndex,currentIndex) => {
        this.onPreview(clockIndex,currentIndex)
    };
  },
  methods: {
    init(obj) {
      this.visible = true;
      this.rowInfo = obj;
      let that = this;
      if (this.rowInfo){
        this.getClockList();//加载打卡地址
      }else{
        setTimeout(function() {
            that.getMyLocation();
        },1000)
      }
    },
    //查询打卡地点
    getClockList(){
        let that = this;
        getClockList(this.rowInfo.id).then((res) => {
            if(res.data.code==0) {
                this.clockInfos = res.data.data;
                setTimeout(function() {
                    that.getMyLocation();
                },1000)
            }
        })
    },
    //第一部分
    //定位获得当前位置信息
    async getMyLocation() {
      let address = "";
      var center = new qq.maps.LatLng(this.rowInfo.startPointLatitude, this.rowInfo.startPointLongitude);
      var map = new qq.maps.Map(document.getElementById('container'), {
        center: center,
        zoom: 13,
        disableDefaultUI: true
      });
      /*var marker = new qq.maps.Marker({
        position: center,
        map: map
      });*/
      var infoWin = new qq.maps.InfoWindow({
        map: map
      });
      var geocoder = new qq.maps.Geocoder({
        complete: function (res) {
          console.log(res);
          address = res.detail.nearPois[0].name;
        }
      });
      /* qq.maps.event.addListener(map, "click", function(event) {
         this.longitude = event.latLng.getLat();
         this.latitude = event.latLng.getLng();
         console.log(event);
         let lat = new qq.maps.LatLng(this.longitude, this.latitude);
         geocoder.getAddress(lat);
       });*/
      var waypoints = '';
      var passingPlaceList = [];
      if (this.clockInfos != null && this.clockInfos.length > 0) {
        passingPlaceList = this.clockInfos;
      } else {
        passingPlaceList = this.rowInfo.passingPlaceList;
      }
      if (passingPlaceList != null && passingPlaceList.length > 0) {
        for (let i = 0; i < passingPlaceList.length; i++) {
          if (i < 30) { //最多支持30个
            waypoints += passingPlaceList[i].pointLongitude + ',' + passingPlaceList[i].pointLatitude + ";"
          }
        }
        waypoints = waypoints.substring(0, waypoints.lastIndexOf(';'));
      }
      //WebServiceAPI请求URL（驾车路线规划默认会参考实时路况进行计算）
      // var url="https://apis.map.qq.com/ws/direction/v1/driving/"; //请求路径
      // url+="?from="+this.rowInfo.startPointLatitude+","+this.rowInfo.startPointLongitude;  //起点坐标
      // url+="&to="+this.rowInfo.endPointLatitude+","+this.rowInfo.endPointLongitude;  //终点坐标
      // if(waypoints!=''){
      //   url+="&waypoints="+waypoints;  //途经坐标
      // }
      // url+="&output=jsonp&callback=callback";	//指定JSONP回调函数名，本例为cb
      // url+="&key=DQVBZ-CQQCO-WJSWI-STRO4-KW5YF-DQBXN"; //开发key，可在控制台自助创建
      // //赋值map
      // this.map = map;
      // //发起JSONP请求，获取路线规划结果
      // this.jsonp_request(url);
      let from = this.rowInfo.startPointLongitude+","+this.rowInfo.startPointLatitude;
      let to = this.rowInfo.endPointLongitude+","+this.rowInfo.endPointLatitude;
      //赋值map
      this.map = map;
      let {data: res} = await directionTdMap(from,to,waypoints);
      if (res.code == 0) {
        this.callback(res.data);
      }
    },
    jsonp_request(url){
      var script=document.createElement('script');
      script.src=url;
      document.body.appendChild(script);
    },
    //定义请求回调函数，在此拿到计算得到的路线，并进行绘制
    callback(ret){
      var that = this;
      // var coords = ret.result.routes[0].polyline;
      // var pl = [];
      // //坐标解压（返回的点串坐标，通过前向差分进行压缩）
      // var kr = 1000000;
      // for (var i = 2; i < coords.length; i++) {
      //   coords[i] = Number(coords[i - 2]) + Number(coords[i]) / kr;
      // }
      // //将解压后的坐标放入点串数组pl中
      // for (var i = 0; i < coords.length; i += 2) {
      //   pl.push(new qq.maps.LatLng(coords[i], coords[i+1]));
      // }
      var coords = ret.split(';');
      var pl = [];
      for (let i = 0; i < coords.length; i++) {
        if(coords[i]==''){
          continue;
        }
        //转换坐标
        pl.push(new qq.maps.LatLng(coords[i].split(',')[1],coords[i].split(',')[0]))
        // let points = wgs84_to_gcj02(coords[i].split(',')[0],coords[i].split(',')[1])
        // pl.push(new qq.maps.LatLng(points[1],points[0]))
      }
      //-------------------------------------------------------------------------------------------------
      //标记起终点marker
      let startLatLng = new qq.maps.LatLng(this.rowInfo.startPointLatitude,this.rowInfo.startPointLongitude)
      var startMarker = new qq.maps.Marker({
        id: 'marker-layer-start',
        map: this.map,
        position:startLatLng,
        icon: new qq.maps.MarkerImage(
            startImg,
            new qq.maps.Size(40, 60),
            new qq.maps.Point(0, 0),
            new qq.maps.Point(20,45)
          )
      })
      var infoWin = new qq.maps.InfoWindow({
        map: this.map
      });
      //标注点击事件
      qq.maps.event.addListener(startMarker, 'click', function () {
        infoWin.open();
        infoWin.setContent('<div style="text-align:center;white-space:nowrap;margin:10px;">'+that.rowInfo.startPointName+'</div>');
        infoWin.setPosition(startLatLng);
      });
      //-----------------------------------------------------------------------------------------
      let endLatLng = new qq.maps.LatLng(this.rowInfo.endPointLatitude,this.rowInfo.endPointLongitude)
      var endMarker = new qq.maps.Marker({
        id: 'marker-layer-end',
        map: this.map,
        position: endLatLng,
        icon: new qq.maps.MarkerImage(
          endImg,
          new qq.maps.Size(40, 60),
          new qq.maps.Point(0, 0),
          new qq.maps.Point(20,45)
        )
      })
      //标注点击事件
      qq.maps.event.addListener(endMarker, 'click', function () {
        infoWin.open();
        infoWin.setContent('<div style="text-align:center;white-space:nowrap;margin:10px;">'+that.rowInfo.endPointName+'</div>');
        infoWin.setPosition(endLatLng);
      })
      //-------------------------------------------------------------------------------------------------
      //标记途径地点
      var passingPlaceList = [];
      var markerImg = tujingImg;
      if(this.clockInfos!=null&&this.clockInfos.length>0){
          passingPlaceList = this.clockInfos;
      }else{
          passingPlaceList = this.rowInfo.passingPlaceList;
      }
      if(passingPlaceList != null && passingPlaceList.length>0){
        for (let i = 0; i < passingPlaceList.length;i++){
          let latLng = new qq.maps.LatLng(passingPlaceList[i].pointLatitude,passingPlaceList[i].pointLongitude)
          if(this.clockInfos!=null&&this.clockInfos.length>0){
              if(this.clockInfos[i].type=='1'){
                  markerImg = empImg;
              }
              if(this.clockInfos[i].type=='2'){
                  markerImg = driverImg;
              }
          }
          var tujingMarker = new qq.maps.Marker({
            id: 'marker-layer'+i,
            map: this.map,
            position: latLng,
            icon: new qq.maps.MarkerImage(
              markerImg,
              new qq.maps.Size(40, 60),
              new qq.maps.Point(0, 0),
              new qq.maps.Point(20,45)
            )
          })
          //标注点击事件
          var that = this;
          qq.maps.event.addListener(tujingMarker, 'click', function () {
              //标注点击事件
              var markerTips = '';
              markerTips = '<div style="text-align:center;white-space:nowrap;margin:10px 10px 0px 10px;">'+passingPlaceList[i].pointName+'</div>';
              if(that.clockInfos!=null&&that.clockInfos.length>0){
                  markerTips+='<div style="text-align:center;white-space:nowrap;margin:0px 10px 10px 10px;">'+passingPlaceList[i].clockTime+'</div>';
                  if(that.clockInfos[i].attachUrls){
                      markerTips+='<div>';
                      that.clockInfos[i].attachUrls.forEach((item,index)=>{
                          markerTips+='<img style="width:50px;height:50px;" onclick="onPreview('+i+','+index+')" src="/api'+item+'"/>';
                      });
                      markerTips+='</div>';
                  }
              }
            infoWin.open();
            infoWin.setContent(markerTips);
            infoWin.setPosition(latLng);
          });
        }
      }
      //----------------------------------------------------------------------------------------------------------
      //绘制路线
      this.display_polyline(pl)//显示路线
    },
    onPreview(clockIndex,currentIndex) {
        this.showViewer = true;
        let tempImgList = [];
        this.clockInfos[clockIndex].attachUrls.forEach(item => {
            let item1 = '/api'+item;
            tempImgList.push(item1);
        });
        let temp = tempImgList.splice(0,currentIndex);
        this.srcList = tempImgList.concat(temp);//将当前图片调整成点击缩略图的那张图片
        console.log(JSON.stringify(this.srcList));
      },
      // 关闭查看器
      closeViewer() {
          this.showViewer = false
      },
    display_polyline(pl){
      //创建 MultiPolyline显示折线
      var polylineLayer = new qq.maps.Polyline({
        id: 'polyline-layer', //图层唯一标识
        map: this.map,//绘制到目标地图
        path: pl,//一个坐标数组，折线、多边形就是依靠这些坐标数组来成形的
        strokeColor:"#28F", //折线颜色
        strokeDashStyle:"solid", //折线样式
        strokeWeight:10, //折线宽度
        editable:false,//折线是否可编辑，即是否可以移动折线中的点，并且可以获取到移动后的位置信息，用事件接受返回值即可qq.maps.event.addListener(polyline,'click',function(res){//res里即包含了位置信息})
        clickable:false //是否可点击
      });
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
